import {Injectable} from "@angular/core";
import { BatteryType, DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class BatteryTypeService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllBatteryTypes();
    }

    getAllBatteryTypes() {
        return this.powerSupplyService.getBatteryTypes().pipe(map(result => result));
    }

    createBatteryType(model: BatteryType) {
        return this.powerSupplyService.createBatteryType(model).pipe(map(result => result));
    }

    updateBatteryType(model: BatteryType) {
        return this.powerSupplyService.updateBatteryType(model).pipe(map(result => result));
    }

    deleteBatteryType(id: number) {
        return this.powerSupplyService.deleteBatteryType(id).pipe(map(result => result));
    }
}
